export default "__VITE_ASSET__uka8QApl__"